// @flow
import React, { PureComponent } from 'react'
import { AkCreateDrawer } from '@atlaskit/navigation'
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left'

export default class CreateDrawer extends PureComponent {
  render() {
    return (
      <AkCreateDrawer
        heading={null}
        key="drawler"
        backIcon={<ArrowLeftIcon label="" />}
        primaryIcon={<ArrowLeftIcon label="" />}
        {...this.props}
      >
        {/*<div key="drawler" style={{ marginTop: -64 }}>*/}
        {/*<AkNavigationItemGroup title="Thêm cấu hình">*/}
        {/*<AkNavigationItem*/}
        {/*href={slug.measuring.create}*/}
        {/*linkComponent={WrapperLinkComponent}*/}
        {/*onClick={this.props.onBackButton}*/}
        {/*icon={Icon.car}*/}
        {/*text="Tạo mới"*/}
        {/*/>*/}
        {/*</AkNavigationItemGroup>*/}
        {/*</div>*/}
      </AkCreateDrawer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layout/navigation-layout/CreateDrawer.js